<template>
  <div class="game">
    <tour
      ref="Tour"
      @done="tourDone = $event"
      @currentStep="tourCurrentStep = $event"
      @currentTarget="tourCurrentTarget = $event"
    />
    <mobile-tutorial
      :is-touch-device="isTouchDevice"
      :show-mobile-help="showMobileHelp"
      @showMobileHelp="showMobileHelp = $event"
    />
    <div class="row">
      <div class="col">
        <h3 v-if="!isTouchDevice">
          {{ getGameInfo().name }}
        </h3>
        <p v-if="!isTouchDevice">
          {{ getGameInfo().taskDesktop }}
        </p>
        <p
          v-if="isTouchDevice"
          class="mt-0"
        >
          {{ getGameInfo().taskTouch }}
        </p>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-primary"
          @click="help"
        >
          Hilfe
        </button>
      </div>
    </div>
    <game-controller
      :is-touch-device="isTouchDevice"
      :tour-current-step="tourCurrentStep"
      :tour-current-target="tourCurrentTarget"
    />
  </div>
</template>

<script>
import Tour from '@/components/Tour.vue'
import MobileTutorial from '@/components/MobileTutorial.vue'
import GameController from '@/components/GameController.vue'
import Level from '@/lib/level'

export default {
  name: 'Game',
  components: {
    Tour,
    MobileTutorial,
    GameController
  },
  data () {
    return {

      tourDone: false,
      tourCurrentStep: undefined,
      tourCurrentTarget: undefined,
      showMobileHelp: false

    }
  },
  computed: {
    // funktion 'isTouchDevice()' von: https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
    isTouchDevice () {
      var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
      var mq = function (query) {
        return !!window.matchMedia(query).matches
      }

      if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch)) {
        return true
      }

      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
      return !!mq(query)
    }
  },
  mounted () {
    window.addEventListener('resize', this.setValues, false)
    window.addEventListener('orientationchange', this.handleOrientationChange)
  },
  methods: {
    getGameInfo () {
      return Level[this.$store.state.currentGame]
    },
    help () {
      if (!this.isTouchDevice) {
        this.$refs.Tour.start()
      } else {
        this.showMobileHelp = true
      }
    },
    handleOrientationChange () {
      location.reload()
    }
  }
}
</script>
